import { TeliaIcon, TeliaLink } from '@teliads/components/react';

import './BillboardTypedLink.scss';
import { TypedLink } from './models';

export function BillboardTypedLink({ type, href, name, openInNewTab, darkBackground }: TypedLink) {
  return (
    <div className="billboard-typed-link">
      <TeliaIcon name={type} data-testid="billboard-typed-link-icon" />
      <TeliaLink
        variant="standalone"
        href={href}
        data-testid="billboard-typed-link-href"
        target={openInNewTab ? '_blank' : ''}
        darkBackground={darkBackground}
      >
        {name}
      </TeliaLink>
    </div>
  );
}
